import React from "react";
import { Link } from "react-router-dom";
import _ from "lodash";

import { formatDateSmall } from "../../../../../utils/dates";
import Table from "../../../../../components/common/table/Table";
import messagesIcon from "../../../../../assets/images/speech-bubble-grey.svg";
import arrowRightIcon from "../../../../../assets/images/arrow-right.svg";
import styles from "./Pitches.scss";

import { Mixpanel } from "../../../../../actions/mixpanel.actions";
import { PROJECT_PITCHES_TABLE } from "../../../../../actions/project.actions";

class Pitches extends React.Component {
  render() {
    const mappedMatches = this.props.pitches.map(pitch => {
      const { project } = pitch.match;
      const { messages } = pitch;

      return {
        rowKey: pitch.id,
        data: [
          {
            displayText: this.getProjectDisplayText(project),
            orderByText: project.title
          },
          {
            displayText: formatDateSmall(pitch.last_activity_at),
            orderByText: pitch.last_activity_at
          },
          {
            displayText: this.getMessagesIcon(project, messages),
            orderByText: messages.length
          }
        ]
      };
    });

    const tableData = {
      headers: [
        {
          displayText: "PROJECT",
          id: "table-member-pitches-sort-project",
          track: "Table - Member Pitches - Sort By Project"
        },
        {
          displayText: "LAST ACTIVITY",
          id: "table-member-pitches-sort-last-activity",
          track: "Table - Member Pitches - Sort By Last Activity"
        },
        {
          displayText: "MESSAGES",
          id: "table-member-pitches-sort-messages",
          track: "Table - Member Pitches - Sort By Messages"
        }
      ],
      rows: mappedMatches
    };

    const defaultSort = {
      headerIndex: 1,
      order: "desc"
    };

    return (
      <div className={styles.pitches}>
        <h2 className={styles.pageTitle}>Pitches</h2>
        <p className={styles.pageSubTitle}>
          Projects for which you’ve pitched are shown here along with their
          latest activity and number of messages between you and the company.
        </p>
        <div className={styles.divider}>
          <div className={styles.top} />
          <div className={styles.bottom} />
        </div>

        <Table
          name={PROJECT_PITCHES_TABLE}
          colsConfig={["50%", "25%", "25%"]}
          defaultSort={defaultSort}
          tableData={tableData}
        />
      </div>
    );
  }

  getProjectDisplayText(project) {
    const company = _.get(project, "employer.profile.company") || {};
    const paused = project.status_id === 10;

    const enabledRowComponent = () => (
      <div className={styles.rowHeader}>
        <div>
          <Link
            to={`/member/company/${company.id}`}
            onClick={() =>
              Mixpanel.track("Member - Pitches - Project Company Name")
            }
          >
            {company.name}
          </Link>
        </div>

        <div className={styles.rowHeaderSubtitle}>
          <Link
            to={`/member/project/${project.id}/detail`}
            onClick={() =>
              Mixpanel.track("Member - Pitches - Project Job Title")
            }
          >
            {project.title}
          </Link>
        </div>
      </div>
    );

    const pausedRowComponent = () => (
      <div className={styles.rowHeader}>
        <div>{company.name}</div>

        <div className={styles.rowHeaderSubtitle}>{project.title}</div>
      </div>
    );

    return paused ? pausedRowComponent() : enabledRowComponent();
  }

  getMessagesIcon(project, messages) {
    const paused = project.status_id === 10;
    let messagesCount = _.isEmpty(messages) ? "0" : messages.length;

    if (messagesCount < 10) {
      messagesCount = "0" + messagesCount;
    }

    const enabledRowComponent = () => (
      <div className={styles.actions}>
        <div className={styles.actionsLeft}>
          <Link
            to={`/member/project/${project.id}/messages`}
            className={styles.messages}
            onClick={() =>
              Mixpanel.track("Member - Pitches - Project Job Messages")
            }
          >
            <img
              src={messagesIcon}
              alt="Messages"
              className={styles.messagesImage}
            />
            <span className={styles.messagesText}>{messagesCount}</span>
          </Link>
        </div>

        <Link
          to={`/member/project/${project.id}/detail`}
          onClick={() => Mixpanel.track("Member - Pitches - Project Arrow")}
        >
          <img src={arrowRightIcon} className={styles.arrowButton} />
        </Link>
      </div>
    );

    const pausedRowComponent = () => (
      <div className={styles.actions}>
        <span>Project Paused</span>
        <span>
          <img src={arrowRightIcon} className={styles.arrowButton} />
        </span>
      </div>
    );

    return paused ? pausedRowComponent() : enabledRowComponent();
  }
}

export default Pitches;



// WEBPACK FOOTER //
// ./src/routes/candidate/projects/pitches/components/Pitches.js